import { render, staticRenderFns } from "./MedicationAction.vue?vue&type=template&id=2be068ca&"
import script from "./MedicationAction.vue?vue&type=script&lang=js&"
export * from "./MedicationAction.vue?vue&type=script&lang=js&"
import style0 from "./MedicationAction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports